import React from 'react';
import './YouTubeFeature.css';

const YOUTUBE_ICON_BASE64 = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABd0lEQVR4nO2UO0sDQRDHf4qFhYVgYWFhYWHhB7CxsLCwsLC0iGBhYWEhFhYWFhYWFhYWFhYWFhYWYmFhYWHxASJyMgv/A8dxl7vL5XKBPxwzszv7m9nZ2T34b1QAG8ARcAc8AW/ABBgDfWAHKOW1XAYOgBugH4g8AlfAFlDKYrwOrAJnwAPwDrwAYyAFXGAT2AfawDXwCEyBH+AZuAQawAKwDJwC98Ar8AU8A7dAE1hJM14DjoEucB8BD0NHwC5QjYFvAefAMCPwBDgBNoC5EPgesyRvMfBboJUTPA5dYAfIhcBbQCcneNhOgW0g7wPPAXUm8VxvAHM+8BLQYzZ0feBFZjvJFdD2gS8BH8yGD6DpAy8yW8EjYM8HXmS2givAhg+8wGwFvwNrPvA8s3XwHVjxgeeAOrN18NUHbvQBnwJNH7hRFbhg+k5OgbIPPKQC0AA6TF/6IbAeA4/QIlBj+tp7wAD4Bp6ADtCI8/Mn9AuaSrYCh5O3YAAAAABJRU5ErkJggg==`;

const YouTubeFeature = () => {
    // Replace with your actual YouTube channel URL
    const channelUrl = "https://www.youtube.com/@adventuresofdanny";
    
    // Replace with your featured video ID (the part after ?v= in the YouTube URL)
    const featuredVideoId = "85wri2CN7NQ";

    return (
        <div className="youtube-feature">
            <h2>Featured Video</h2>
            <div className="video-container">
                <iframe
                    src={`https://www.youtube.com/embed/${featuredVideoId}`}
                    title="Featured YouTube video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                ></iframe>
            </div>
            <a 
                href={channelUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="channel-button"
            >
                <img 
                    src={YOUTUBE_ICON_BASE64}
                    alt="YouTube Icon"
                    className="youtube-icon"
                />
                Visit My YouTube Channel
            </a>
        </div>
    );
};

export default YouTubeFeature;
